export const SET_ON_APPLICATION_STARTED = 'InteractionInterface.v1_0.SetOnApplicationStartedMethod';
